import { useEffect, useRef } from 'react';
import { bootIntercom, shutdownIntercom } from '@/providers/intercom';
import type { User } from '@/types/auth.types';

/**
 * Keeps the Intercom Messenger bound to `user`, keyed on uid: sign-out shuts it down, and the next
 * user (or the same one again) gets a fresh boot. Waits for `signed` to resolve so a signed boot
 * isn't preceded by an unsigned one.
 */
export const useIntercomSession = (user: User | null, signed: boolean | undefined): void => {
  const bootedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    const userId = user?.uid ?? null;
    if (bootedUserIdRef.current === userId) return;
    if (bootedUserIdRef.current) {
      shutdownIntercom();
      bootedUserIdRef.current = null;
    }
    if (!user || signed === undefined) return;
    bootedUserIdRef.current = user.uid;
    void bootIntercom(user, signed, () => bootedUserIdRef.current);
  }, [user, signed]);
};
